import React, { useState } from 'react'
import {FaHandMiddleFinger,FaShare, FaVuejs} from 'react-icons/fa'
import Box from './Box';
import FuelBox from './FuelBox';
import WeightBox from './WeightBox'
import {LoaderLeft} from './Loader'
import {IVAO} from '../icons/Icon'
const Details = ({ofp,username}) => {
    let weightdata,fueldata,unit;
    if(ofp){
        ofp = JSON.parse(ofp);
        fueldata = ofp.fuel;
        weightdata = ofp.weights;
        unit = ofp.params.units;
    }

    const shareyourplan = where => {
        // switch (where) {
        //     case 'ivao':
        //         document.querySelector("#sentoivao form").submit()
        //         break;
        //     case 'vatsim':
        //         document.querySelector("#sentovatsim form").submit()
        //         break;
        //     default:
        //         break;
        // }
    }

    const [showFuelInfo, setShowFuelInfo] = useState(true);
    return (
        ofp != null  ? (<div className="flex flex-1 flex-col text-white py-6 px-6 ">
        <div className="flex items-center justify-between">
            <h4 className="font-semibold text-xl flex h-8 items-center">
                {username === 'ematejce' && <FaHandMiddleFinger className="mr-2"/>} Hii {username.charAt(0).toUpperCase() + username.slice(1)}!
            </h4>
            <div className="flex space-x-2">
                <a 
                className="block hover:bg-bordercolor3 p-3 transform transition-colors duration-300"
                onClick={shareyourplan}
                >   
                    <FaShare/>
                </a>
                <a 
                className="block relative w-16 hover:bg-bordercolor3 p-3 transform transition-colors duration-300"
                onClick={ () => { document.querySelector("#sentoivao form").submit()}}
                >   
                    <IVAO className="" />
                </a>
                <a 
                className="block hover:bg-bordercolor3 p-3 transform transition-colors duration-300"
                onClick={ () => { document.querySelector("#sentovatsim form").submit()}}
                >   
                    <FaVuejs/>
                </a>
                <a target="_BLANK" href={`https://www.simbrief.com/system/dbquery.php?target=map&routedata=${ofp.files.pdf.link.split(".")[0].replace("PDF", "MJS")}.js`} className="flex w-full justify-center font-medium items-center focus:outline-none bg-primary hover:opacity-90 px-6 transform transition-opacity duration-200">Open In Map</a>
               
            </div>
        </div>
        <div className="md:flex mt-5">
           <div className="flex flex-col space-y-3 mb-5 lg:mb-0"> 
                <ul className="flex space-x-2">
                    <li className={`w-1/2 border font-semibold flex justify-center py-2 cursor-pointer ${ showFuelInfo ? 'border-primary text-primary' : 'border-bordercolor3'}`} onClick={() => {setShowFuelInfo(true)}} >
                        <a>
                            Fuel
                        </a>
                    </li>
                    <li className={`w-1/2 border font-semibold flex justify-center py-2 cursor-pointer ${ !showFuelInfo ? 'border-primary text-primary' : 'border-bordercolor3'}`} onClick={() => {setShowFuelInfo(false)}} >
                        <a>
                            Weights
                        </a>
                    </li>
                </ul>
                {showFuelInfo ? <FuelBox fueldata={fueldata} unit={unit}/> : <WeightBox weightdata={weightdata} unit={unit}/>}
                <textarea placeholder="Skretchpad.." rows="5" className="w-full  p-4 bg-black hidden md:block border border-bordercolor3 focus:border-white transform transition-colors duration-200"></textarea>
           </div>
           <div className="flex flex-col w-full flex-1 md:ml-3">
                <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mb-4">
                    <Box title="Departure">
                        {ofp.origin.icao_code} <span className="text-base">(elev. {ofp.origin.elevation}ft)</span>
                    </Box>
                    <Box title="Destination">
                        {ofp.destination.icao_code} <span className="text-base">(elev. {ofp.destination.elevation}ft)</span>
                    </Box>
                    <Box title="Alternate">
                        {ofp.alternate.icao_code} <span className="text-base">(elev. {ofp.alternate.elevation}ft)</span>
                    </Box>
                    <Box title="Callsign">
                        {ofp.atc.callsign}
                    </Box>
                    <Box title="Aircraft">
                        {ofp.aircraft.icaocode}
                    </Box>
                    <Box title="Cruise">
                        {ofp.general.initial_altitude + 'ft'}
                    </Box>
                </div>
                <Box title="Route" className="mb-4">
                    {`${ofp.origin.icao_code}/${ofp.origin.plan_rwy} ${ofp.general.route} ${ofp.destination.icao_code}/${ofp.destination.plan_rwy} `}
                </Box>
                <Box title="Alternate Route">
                    {`${ofp.alternate.route} ${ofp.alternate.icao_code}/${ofp.alternate.plan_rwy} `}
                </Box>
           </div>
        </div>
        <div id="sentoivao" className="hidden opacity-0" dangerouslySetInnerHTML={{__html: ofp.ivao_prefile}}>
            </div>

            <div id="sentovatsim" className="hidden opacity-0" dangerouslySetInnerHTML={{__html: ofp.vatsim_prefile}}>
            </div>
    </div>) : ( <div className="py-6 px-6 text-black mt-12">
        <LoaderLeft className="fill-current"/>
    </div> )
    )
}

export default Details
